import { render, staticRenderFns } from "./information.vue?vue&type=template&id=b8b7d3b8&scoped=true"
import script from "./information.vue?vue&type=script&lang=js"
export * from "./information.vue?vue&type=script&lang=js"
import style0 from "./information.vue?vue&type=style&index=0&id=b8b7d3b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b7d3b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8b7d3b8')) {
      api.createRecord('b8b7d3b8', component.options)
    } else {
      api.reload('b8b7d3b8', component.options)
    }
    module.hot.accept("./information.vue?vue&type=template&id=b8b7d3b8&scoped=true", function () {
      api.rerender('b8b7d3b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/customerManage/claimForm/information.vue"
export default component.exports